<template>
    <div v-if="ui.features.bookmarks.opened" dusk="ReaderBookmarks" class="flex flex-1 flex-col overflow-hidden">
        <div class="flex-1 overflow-y-auto overflow-x-hidden">
            <div
                v-if="bookmarks.length === 0"
                role="status"
                aria-live="polite"
                class="flex h-full w-full items-center justify-center px-4 text-center text-theme-text"
            >
                <p class="text-sm opacity-60">
                    {{ localizations[lang].noBookmarks }}
                </p>
            </div>
            <template v-else>
                <SectionLabel>{{ bookmarks.length }} {{ localizations[lang].bookmarks }}</SectionLabel>
                <BookmarkList :bookmarks="bookmarks" />
            </template>
        </div>
    </div>
</template>

<script>
'use strict';

import { mapGetters, mapState } from 'vuex';
import BookmarkList from '../partials/BookmarkList.vue';
import SectionLabel from '../partials/SectionLabel.vue';

export default {
    name: 'ReaderBookmarks',
    components: {
        BookmarkList,
        SectionLabel,
    },
    computed: {
        ...mapState(['ui', 'localizations', 'lang']),
        ...mapGetters(['bookmarks']),
    },
};
</script>
